import React from "react";
import MenuItem from "@hui/_molecules/dropdowns/menu/MenuItem";
import MoreActions from "@hui/_molecules/dropdowns/more_actions/MoreActions";
import I18n from "../../../../../utilities/translations";


const MenuActions = ({intercomLink} : {intercomLink: string}) => (
  <div className="tw-flex tw-mr-1">
    <MoreActions>
      <MenuItem label={"I'll do it later"} href="/" trackClick={{ eventName: "onboarding_tour_do_it_later_click"}} />
      <MenuItem label={"Talk to the team"} href={intercomLink} trackClick={{ eventName: "onboarding_tour_request_help_click"}} />
      <MenuItem label={I18n.t("home.uk_waitlist.more_actions.sign_out")} href="/users/sign_out" trackClick={{ eventName: "onboarding_tour_logout_click"}} />    </MoreActions>
  </div>
);

export default MenuActions;